const API_BASE = process.env.REACT_APP_API_URL || '/api';

const post = async (path, body, fallbackError) => {
  const headers = { 'Content-Type': 'application/json' };
  if (window.__sessionId) headers['X-Session-ID'] = window.__sessionId;

  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) throw new Error(data.error || fallbackError);
  return data;
};

const TwilioWhatsAppService = {
  async sendBillingReceipt(billingId) {
    return post('/whatsapp/billing', { billing_id: billingId }, 'Failed to send WhatsApp message');
  },

  async sendEstimate(estimateId, extra = {}) {
    return post('/whatsapp/estimate', { estimate_id: estimateId, ...extra }, 'Failed to send WhatsApp message');
  },

  async sendSchemeReminder(enrollmentId) {
    return post('/whatsapp/scheme-reminder', { enrollment_id: enrollmentId }, 'Failed to send WhatsApp reminder');
  },
};

export default TwilioWhatsAppService;
